import store from '../store';

export default {
    /**
     * 非流式普通问答
     */
    async sendHttpChat (payload, sessionId) {
        let token = store.state.account.token;
        let apiPre = '/call-platform';
        if (location.hash.indexOf('transGpt') !== -1) {
            apiPre = '/only-mem-server';
        }
        let API = apiPre + '/api/chat/once?sessionId=' + sessionId;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers, body: JSON.stringify(payload) });
        console.log('resp', resp);
        if (!resp.ok) {
            resp.statusCode = resp.status;
            return resp;
        }
        let ret = await resp.json();
        ret.status = 200;
        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        return ret;
    }
};
